import { useCallback, useContext, useEffect, useRef } from "react";
import modalStyle from "../modal.module.css";
import buttonStyle from "../../buttons.module.css";
import { AppContext } from "../../../../contexts/AppContext";
import { X } from "lucide-react";

export interface GenericModalData {
  content: React.ReactNode;
  closeAction?: () => void;
}

function GenericModal({ content, closeAction }: Readonly<GenericModalData>) {
  const dialogRef = useRef<HTMLDialogElement>(null);
  const { setShowModal } = useContext(AppContext);

  const closeModal = useCallback(() => {
    setShowModal("none", undefined);
    if (closeAction) closeAction();
  }, [closeAction, setShowModal]);

  useEffect(() => {
    const dialog = dialogRef?.current;
    if (dialog) {
      dialog.showModal();
      dialog.addEventListener("close", closeModal);
    }

    return () => {
      if (dialog) {
        dialog.removeEventListener("close", closeModal);
      }
    };
  }, [closeModal]);

  return (
    <dialog ref={dialogRef} className={modalStyle.dialog + " " + modalStyle.modalStyle + " " + modalStyle.genericDialog}>
      <button className={modalStyle.modalCloseButton + " " + buttonStyle.closeButton} onClick={closeModal}>
        <X className={modalStyle.modalCloseIcon} stroke="white" strokeWidth="1.5" />
      </button>
      {content}
    </dialog>
  );
}

export default GenericModal;
